var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import ndarray from "ndarray";
import tile from "ndarray-tile";
import unpack from "ndarray-unpack";
import pack from "ndarray-pack";
export function range(n) {
    var out = new Float32Array(n);
    for (var i = 0; i < n; i++) {
        out[i] = i;
    }
    return out;
}
export function rangeDup(n, multi) {
    if (multi === void 0) { multi = 4; }
    var out = new Float32Array(n * multi);
    for (var i = 0; i < n * multi; i++) {
        out[i] = Math.floor(i / multi);
    }
    return out;
}
export function duplicate(arr, multi) {
    if (multi === void 0) { multi = 4; }
    var out = tile(arr, [1, multi]);
    out = ndarray(out.data);
    return out;
}
export function makePair(arr, multi) {
    if (multi === void 0) { multi = 2; }
    if (arr.size <= 1)
        return [];
    var offset = Math.floor(multi / 2);
    var out = arr;
    out = tile(out, [1, multi]);
    out = out.transpose(1, 0);
    var tmpOut = unpack(out);
    for (var i = 0; i < offset; i++) {
        tmpOut[0].pop();
        tmpOut[1].shift();
    }
    out = pack(tmpOut);
    out = out.transpose(1, 0);
    out = tile(out, [1, 1, 2]);
    out = out.transpose(0, 2, 1);
    out = unpack(out).reduce(function (p, v) { return __spread(p, v); }, []);
    return out;
}
/**
 * Convert integer to float for shaders.
 */
export function float(i) {
    if (i - Math.floor(i) > 0) {
        return i;
    }
    return Math.floor(i) + ".0";
}
export function exportCanvas(canvas, upsideDown, opacityConfig) {
    var exportCanvas = document.createElement("canvas");
    exportCanvas.width = 1000;
    exportCanvas.height = 500;
    var context = exportCanvas.getContext("2d");
    if (upsideDown) {
        context.scale(1, -1);
    }
    console.log(opacityConfig);
    for (var id in canvas) {
        var cvs = canvas[id];
        context.globalAlpha = opacityConfig ? opacityConfig[id] : 1;
        context.drawImage(cvs, 0, upsideDown ? -cvs.height : 0);
    }
    var exportBtn = document.createElement("a");
    exportBtn.href = exportCanvas
        .toDataURL()
        .replace(/^data:image\/[^;]*/, "data:application/octet-stream");
    exportBtn.download = "export.png";
    exportBtn.click();
}
export function slope(array, min, max) {
    return array.map(function (x) { return Math.max(min, Math.min(max, x)); });
}
